import logo from "./logo.svg";
import "./App.css";
import { Routes, Route, HashRouter, BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Slide } from "react-toastify";
import Home from "./Pages/Home/Home";
import CartDetails from "./Pages/CartDetails/CartDetails";
import ContactUs from "./Pages/ContactUs/ContactUs";
import Howitswork from "./Pages/Howitswork/Howitswork";
import Orders from "./Pages/Orders/Orders";
import PaymentFailed from "./Pages/PaymentFailed/PaymentFailed";
import PaymentSuccess from "./Pages/PaymentSuccess/PaymentSuccess";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";
import ProductDetail from "./Pages/ProductDetail/ProductDetail";
import Profile from "./Pages/Profile/Profile";
import ReferralCode from "./Pages/ReferralCode/ReferralCode";
import TermsAndConditons from "./Pages/TermsAndConditons/TermsAndConditons";
import VendorProductsDetail from "./Pages/VendorProductDetail/VendorProductDetail";
import ReferralsProgram from "./Pages/ReferralsProgram/ReferralsProgram";
import Wallet from "./Pages/Wallet/Wallet";
import Winning from "./Pages/Winning/Winning";
import FestivalProducts from "./Pages/FestivalProducts/FestivalProducts";
import FestivalWinnerGift from "./Pages/FestivalWinnerGift/FestivalWinnerGift";
import UploadAndListing from "./Pages/UploadAndListing/UploadAndListing";
import BannerAnalytic from "./Pages/BannerAnalytic/BannerAnalytic";
import CustomerQueries from "./Pages/CustomerQueries/CustomerQueries";
import PromotionalBannerQueryList from "./Pages/PromotionalBannerQueryList/PromotionalBannerQueryList";
import CustomerOrders from "./Pages/CustomerOrders/CustomerOrders";
import Blogs from "./Pages/Blogs/Blogs";
import AddPoints from "./Pages/AdminPages/AddPoints/AddPoints";
import BlogsReadMore from "./Components/BlogsComponent/BlogsReadMore";
import DefaultSetting from "./Pages/AdminPages/DefaultSetting/DefaultSetting";
import PromoCode from "./Pages/AdminPages/PromoCode/PromoCode";
import AddBlogs from "./Pages/AdminPages/AddBlogs/AddBlogs";
import AddEvents from "./Pages/AdminPages/AddEvents/AddEvents";
import AddPromotionalBanner from "./Pages/AdminPages/AddPromotionalBanner/AddPromotionalBanner";
import AddRewards from "./Pages/AdminPages/AddRewards/AddRewards";
import AssignRoles from "./Pages/AdminPages/AssignRoles/AssignRoles";
import AffiliatePartnerRequest from "./Pages/AdminPages/AffiliatePartnerRequest/AffiliatePartnerRequest";
import AllItems from "./Pages/AdminPages/AllItems/AllItems";
import AssignUsersToManager from "./Pages/AdminPages/AssignUsersToManager/AssignUsersToManager";
import AllTransactions from "./Pages/AdminPages/AllTransactions/AllTransactions";
import ContactUsQueries from "./Pages/AdminPages/ContactUsQueries/ContactUsQueries";
import WinnerStatus from "./Pages/AdminPages/WinnerStatus/WinnerStatus";
import PrivateRoute from "./Pages/utils/PrivateRoute";
import LandingPage from "./Pages/LandingPage/LandingPage";
import PromotionalBannerDetail from "./Pages/PromotionalBannerDetail/PromotionalBannerDetail";
import AllProducts from "./Pages/AllProducts/AllProducts";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FilterPage from "./Pages/FilterPage/FilterPage";

function App() {
  return (
    <div>
      <ToastContainer
        position="top-right"
        transition={Slide}
        autoClose={5000}
        closeOnClick
        theme="colored"
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/allproducts" element={<AllProducts />} />
          <Route path="/landingpage" element={<LandingPage />} />
          <Route
            path="/cartdetails"
            element={
              <PrivateRoute>
                <CartDetails />
              </PrivateRoute>
            }
          />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/howitwork" element={<Howitswork />} />
          <Route
            path="/orders"
            element={
              <PrivateRoute>
                <Orders />
              </PrivateRoute>
            }
          />
          <Route
            path="/paymentfailed/:totalvalue"
            element={
              <PrivateRoute>
                <PaymentFailed />
              </PrivateRoute>
            }
          />
          <Route
            path="/paymentsuccess/:totalValue"
            element={
              <PrivateRoute>
                <PaymentSuccess />
              </PrivateRoute>
            }
          />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route
            path="/productdetail/:productDetailId"
            element={<ProductDetail />}
          />
          <Route
            path="/filter/:categoryId"
            element={<FilterPage />}
          />
          <Route
            path="/promotionalbannerdetail/:promotionalbannerdetail"
            element={<PromotionalBannerDetail />}
          />
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            }
          />
          <Route
            path="/referralcode/:code"
            element={
              <PrivateRoute>
                <ReferralCode />
              </PrivateRoute>
            }
          />
          <Route path="/termsandconditons" element={<TermsAndConditons />} />
          <Route
            path="/vendorproductsdetail/:code"
            element={<VendorProductsDetail />}
          />
          <Route
            path="/vendorproductsdetail"
            element={<VendorProductsDetail />}
          />
          <Route path="/referralsprogram" element={<ReferralsProgram />} />
          <Route
            path="/wallet"
            element={
              <PrivateRoute>
                <Wallet />
              </PrivateRoute>
            }
          />
          <Route path="/winning" element={<Winning />} />
          <Route path="/festivalWinnersGift" element={<FestivalWinnerGift />} />
          <Route
            path="/uploadandlisting"
            element={
              <PrivateRoute>
                <UploadAndListing />
              </PrivateRoute>
            }
          />
          <Route
            path="/banneranalytic"
            element={
              <PrivateRoute>
                <BannerAnalytic />
              </PrivateRoute>
            }
          />
          <Route
            path="/customerqueries"
            element={
              <PrivateRoute>
                <CustomerQueries />
              </PrivateRoute>
            }
          />
          <Route
            path="/promotionalbannerquerylist"
            element={
              <PrivateRoute>
                <PromotionalBannerQueryList />
              </PrivateRoute>
            }
          />
          <Route
            path="/customerorders"
            element={
              <PrivateRoute>
                <CustomerOrders />
              </PrivateRoute>
            }
          />
          <Route
            path="/addpoints"
            element={
              <PrivateRoute>
                <AddPoints />
              </PrivateRoute>
            }
          />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:id" element={<BlogsReadMore />} />
          <Route path="/defaultsetting" element={<DefaultSetting />} />
          <Route
            path="/promocode"
            element={
              <PrivateRoute>
                <PromoCode />
              </PrivateRoute>
            }
          />
          <Route
            path="/addblogs"
            element={
              <PrivateRoute>
                <AddBlogs />
              </PrivateRoute>
            }
          />
          <Route
            path="/addevents"
            element={
              <PrivateRoute>
                <AddEvents />
              </PrivateRoute>
            }
          />
          <Route
            path="/addpromotionalbanner"
            element={
              <PrivateRoute>
                <AddPromotionalBanner />
              </PrivateRoute>
            }
          />
          <Route
            path="/addrewards"
            element={
              <PrivateRoute>
                <AddRewards />
              </PrivateRoute>
            }
          />
          <Route
            path="/assignroles"
            element={
              <PrivateRoute>
                <AssignRoles />
              </PrivateRoute>
            }
          />
          <Route
            path="/affiliatepartnerrequest"
            element={
              <PrivateRoute>
                <AffiliatePartnerRequest />
              </PrivateRoute>
            }
          />
          <Route
            path="/allitems"
            element={
              <PrivateRoute>
                <AllItems />
              </PrivateRoute>
            }
          />
          <Route
            path="/assignuserstomanager"
            element={
              <PrivateRoute>
                <AssignUsersToManager />
              </PrivateRoute>
            }
          />
          <Route
            path="/alltransactions"
            element={
              <PrivateRoute>
                <AllTransactions />
              </PrivateRoute>
            }
          />
          <Route
            path="/contactusqueries"
            element={
              <PrivateRoute>
                <ContactUsQueries />
              </PrivateRoute>
            }
          />
          <Route
            path="/winnerstatus"
            element={
              <PrivateRoute>
                <WinnerStatus />
              </PrivateRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
